/** A saved reply's words for its card (the queue-and-chat-column round, 2026-11-03, part five): the composer's HTML kept on the server is the
 *  person's own and only theirs to see, but the card still draws it through an allow-list, the reply box's own marks only (paragraphs, line
 *  breaks, bold, italic, underline, strike, links, lists, quotes, code). Anything else keeps its text and loses its tag; a link keeps only an
 *  http, https or mailto address and opens in a new tab; pictures were stripped before the save (the server's rule) and are dropped here too. */
const KEPT = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "S", "A", "OL", "UL", "LI", "BLOCKQUOTE", "CODE", "PRE", "SPAN"]);
const DROPPED = new Set(["SCRIPT", "STYLE", "IMG", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "TEMPLATE"]);
const SAFE_LINK = /^(https?:|mailto:)/i;

function cleanNode(node: Node, doc: Document): Node | null {
  if (node.nodeType === Node.TEXT_NODE) return doc.createTextNode(node.textContent ?? "");
  if (node.nodeType !== Node.ELEMENT_NODE) return null;
  const el = node as Element;
  if (DROPPED.has(el.tagName)) return null;
  const kids = [...el.childNodes].map((c) => cleanNode(c, doc)).filter((c): c is Node => !!c);
  if (!KEPT.has(el.tagName)) { const frag = doc.createDocumentFragment(); kids.forEach((k) => frag.appendChild(k)); return frag; }
  const out = doc.createElement(el.tagName.toLowerCase());
  const href = el.tagName === "A" ? el.getAttribute("href") ?? "" : "";
  if (href && SAFE_LINK.test(href.trim())) { out.setAttribute("href", href.trim()); out.setAttribute("target", "_blank"); out.setAttribute("rel", "noopener noreferrer"); }
  kids.forEach((k) => out.appendChild(k));
  return out;
}

/** the HTML the card shows; empty when the browser cannot parse (never the raw text as HTML) */
export function cleanDraftHtml(html: string): string {
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const box = doc.createElement("div");
  for (const c of [...doc.body.childNodes]) { const n = cleanNode(c, doc); if (n) box.appendChild(n); }
  return box.innerHTML;
}
